<template>
  <div>
    <div>
      <h1 class="titleFull">Tool Box Meeting 회의록</h1>
      <table>
        <colgroup>
          <col width="180" />
          <col />
          <col width="180" />
          <col />
        </colgroup>
        <tr>
          <th>현장명</th>
          <td>{{ form.stdInfo.field_name }}</td>
          <th>소속명</th>
          <td>{{ form.stdInfo.com_name }}</td>
        </tr>
        <tr>
          <th>부서명</th>
          <td>{{ form.stdInfo.section }}</td>
          <th>직책</th>
          <td>{{ form.stdInfo.rank }}</td>
        </tr>
        <tr>
          <th>작성자</th>
          <td>{{ form.stdInfo.writer_name }}</td>
          <th>작성일</th>
          <td>{{ form.stdInfo.date }}</td>
        </tr>
        <tr>
          <th>TBM 일시</th>
          <td colspan="3">
            {{ form.inputB_1 | moment("YYYY년 MM월 DD일") }}<span v-if="!!form.inputB_1 && (!!form.inputB_2 || !!form.inputB_3)">, </span> {{ form.inputB_2 | time }}<span v-if="!!form.inputB_2 || !!form.inputB_3">~</span
            >{{ form.inputB_3 | time }}
          </td>
        </tr>
        <tr>
          <th>해당기간</th>
          <td colspan="3">{{ form.inputB_8.sDate }} <span v-if="!!form.inputB_8.sDate || !!form.inputB_8.eDate">~</span> {{ form.inputB_8.eDate }}</td>
        </tr>
        <tr>
          <th>작업명</th>
          <td colspan="3">{{ form.inputB_4 }}</td>
        </tr>
        <tr>
          <th>작업내용</th>
          <td colspan="3">{{ form.inputB_5 }}</td>
        </tr>
        <tr>
          <th>TBM 장소</th>
          <td>{{ form.inputB_6 }}</td>
          <th>위험성평가 실시여부</th>
          <td>
            <div class="flex items-center justify-center gap-4">
              <PrintRadio label="예" :value="form.inputB_7 === '예'" class="justify-center" />
              <PrintRadio label="아니오" :value="form.inputB_7 === '아니오'" class="justify-center" />
            </div>
          </td>
        </tr>
      </table>
      <table v-if="0 < form.risk_factors.length" class="print-container">
        <colgroup>
          <col width="180" />
        </colgroup>
        <tr>
          <th>연변</th>
          <th>잠재위험요인</th>
          <th>대책 (제거→대체→통제 순서고려)</th>
        </tr>

        <tr v-for="(item, item_i) in form.risk_factors" :key="`risk_factors_${item_i}`">
          <td>{{ item.id }}</td>
          <td>{{ item.input1 }}</td>
          <td>{{ item.input2 }}</td>
        </tr>
      </table>
      <table v-if="0 < form.participant.length" class="print-container">
        <tr>
          <th colspan="6">참석자 명단</th>
        </tr>
        <tr>
          <th>공종</th>
          <th>이름</th>
          <th>서명</th>
          <th>공종</th>
          <th>이름</th>
          <th>서명</th>
        </tr>
        <tr v-for="(item, item_i) in Math.ceil(form.participant.length / 2)" :key="`participant_${item_i}`">
          <td>{{ form.participant[item_i * 2].type }}</td>
          <td>{{ form.participant[item_i * 2].name }}</td>
          <td class="relative">
            <img v-if="!!form.participant[item_i * 2].sign" :src="form.participant[item_i * 2].sign" class="absolute w-full h-full top-0 left-0 object-contain" />
          </td>
          <td>{{ !!form.participant[item_i * 2 + 1] ? form.participant[item_i * 2 + 1].type : "" }}</td>
          <td>{{ !!form.participant[item_i * 2 + 1] ? form.participant[item_i * 2 + 1].name : "" }}</td>
          <td class="relative">
            <img v-if="!!form.participant[item_i * 2 + 1] && !!form.participant[item_i * 2 + 1].sign" :src="form.participant[item_i * 2 + 1].sign" class="absolute w-full h-full top-0 left-0 object-contain" />
          </td>
        </tr>
      </table>
    </div>

    <!-- TBM 회의 사진대지 -->
    <div v-if="showPhotoList" class="print-container">
      <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="true" section-title="-" placeholder="신축현장 점검" :customTitle="true">
        <template #customTitle>
          <h1 class="titleFull text-left no-underline">□ TBM 회의 사진대지</h1>
        </template>
      </photo-upload-grid-module>
    </div>
  </div>
</template>

<script>
import PrintRadio from "@/components/print/PrintRadio.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import moment from "moment";
export default {
  name: "Print531",
  components: {
    PrintRadio,
    PhotoUploadGridModule,
  },
  props: {
    form: Object,
  },
  filters: {
    time(val) {
      if (val) return moment(val, "HH:mm:ss").format("HH:mm");
      else return "";
    },
  },
  computed: {
    showPhotoList() {
      return this.form.photoList.reduce((acc, cur) => {
        return acc || !!cur.path;
      }, false);
    },
  },
};
</script>

<style lang="scss" scoped>
$border-color: #cdcdcd;
$approval-border: 2px solid #cdcdcd;
$bg-color: #f9f9f9;

.titleFull {
  font-size: 32px;
  font-weight: 700;
  text-align: center;
  text-decoration: underline;
  padding: 30px 0;
}
table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  &:nth-child(n + 2) {
    margin-top: -1px;
  }

  th,
  td {
    height: 65px;

    font-size: 16px;
    font-weight: 400;
    text-align: center;

    border: 1px solid $border-color;
    padding: 20px 0;
  }

  th {
    font-weight: 500;

    background: $bg-color;
  }
}
</style>
